import { render, staticRenderFns } from "./TermsManagement.vue?vue&type=template&id=9ac0a26a&scoped=true&"
import script from "./TermsManagement.vue?vue&type=script&lang=ts&"
export * from "./TermsManagement.vue?vue&type=script&lang=ts&"
import style0 from "./TermsManagement.vue?vue&type=style&index=0&id=9ac0a26a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac0a26a",
  null
  
)

export default component.exports